import { Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";
import { SHOP } from "@/lib/api";
import Logo from "@/components/Logo";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const links = [
    { label: "Services", href: "#services" },
    { label: "About", href: "#about" },
    { label: "Book", href: "#booking" },
    { label: "Contact", href: "#contact" },
  ];
  return (
    <nav data-testid="main-navbar" className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-xl border-b border-[#2e2e2e]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-28 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-4">
          <Logo className="h-28 w-28 object-contain -my-2" />
          <div className="hidden sm:block leading-none">
            <div className="font-['Anton'] text-chrome text-3xl tracking-wide">MID DEL AUTO</div>
            <div className="font-['Exo_2'] text-[10px] uppercase tracking-[0.35em] text-gray-500 font-bold mt-1.5">Complete Auto Repair</div>
          </div>
        </a>
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a key={l.label} href={l.href} data-testid={`nav-${l.label.toLowerCase()}-link`}
              className="font-['Exo_2'] uppercase text-xs tracking-[0.25em] font-bold text-gray-300 hover:text-[#e10600] transition-colors">
              {l.label}
            </a>
          ))}
          <a href={`tel:${SHOP.phoneTel}`} data-testid="nav-call-button"
            className="inline-flex items-center gap-2 bg-[#e10600] hover:bg-[#ff1a1a] text-white px-5 py-3 uppercase tracking-widest text-xs font-bold transition-colors">
            <Phone className="w-4 h-4" /> {SHOP.phone}
          </a>
          <Link to="/admin/login" data-testid="nav-admin-link" className="font-['Exo_2'] text-[10px] uppercase tracking-[0.3em] text-gray-500 hover:text-white">Admin</Link>
        </div>
        <button data-testid="mobile-menu-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-black border-t border-[#2e2e2e] px-6 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} data-testid={`mnav-${l.label.toLowerCase()}-link`}
              className="block font-['Exo_2'] uppercase text-sm tracking-widest text-gray-300 hover:text-[#e10600]">{l.label}</a>
          ))}
          <a href={`tel:${SHOP.phoneTel}`} className="block bg-[#e10600] text-white text-center py-3 uppercase text-sm font-bold tracking-widest">Call {SHOP.phone}</a>
          <Link to="/admin/login" className="block text-gray-500 text-xs uppercase tracking-widest">Admin Login</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
